import { createFileRoute, Outlet } from "@tanstack/react-router";

import { Header } from "~/components/Header";
import { ImpersonationBanner } from "~/components/ImpersonationBanner";
import { ContractFlowProvider } from "~/components/machtiging-ondertekenen";

// Persistent app shell: Header stays mounted across the main sections (dashboard,
// mijn-gegevens, …) so navigating between them only swaps the Outlet, not the header.
export const Route = createFileRoute("/(authenticated)/_app")({
  component: AppShell,
});

function AppShell() {
  return (
    <ContractFlowProvider>
      <div
        data-slot="app-shell"
        className="bg-brand-darker mx-auto flex min-h-screen flex-col px-[5%]"
      >
        <ImpersonationBanner />
        <Header />

        <main className="flex flex-1 flex-col pb-[5%]">
          <div className="bg-background flex-1 overflow-hidden">
            <Outlet />
          </div>

          <a
            href="/terms"
            data-slot="app-shell-terms"
            target="_blank"
            className="text-brand-white mt-6 self-start text-sm underline underline-offset-4"
          >
            Algemene voorwaarden
          </a>
        </main>
      </div>
    </ContractFlowProvider>
  );
}
